module.exports = __webpack_public_path__ + "static/media/help.debafa63.svg";